<!--
/**
* @name: Add.vue
* @description: 交易管理-添加下单规则
* @author: 杨波
* @create: 2020/09/11 14:06:58
* @update: 2020/09/11 14:06:58
*/
-->
<template>
  <y-view :loading="isLoading">
    <template v-if="!isView">
      <y-form title="下单规则设置:" titleAlign="right" titleWidth="100px" contentWidth="100%">
        <y-form-item title="规则名称:" required>
          <k-input placeholder="请输入名称" block clearable v-model="editPara.name" :class="css.inputW"></k-input>
        </y-form-item>
        <y-form-item title="贸易模式:" required>
          <div>
            <k-checkbox v-for="item in tradeList" :key="item.dvcode" type="arr" :data-arr.sync="editPara.tradeModeList" :value="item.dvcode" :text="item.dvname"></k-checkbox>
          </div>
        </y-form-item>
        <y-form-item title="销售渠道:" block required>
          <k-select2
            v-model="editPara.saleChannelList"
            :data="channelList"
            text-field="name"
            search-field="name"
            key-field="code"
            style="width: 300px;"
            layer-width="auto"
            layerMinWidthEqual
            :nearby="true"
            placeholder="请选择销售渠道"
          ></k-select2>
        </y-form-item>
        <y-form-item title="规则设置:" block required align="top">
          <y-query spaceBetween :hasSearchButton="false">
            <y-query-item>
              <k-select placeholder="请选择" clearable :class="css.selectW" v-model="editPara.validBy">
                <k-option v-for="(value, key) in validByOptionMap" :selected="editPara.validBy == key" :key="key" :value="key" :label="value">{{ value }}</k-option>
              </k-select>
            </y-query-item>
            <y-query-item>
              <k-select placeholder="请选择" clearable :class="css.selectW" v-model="editPara.validRange" :disabled="editPara.validBy == 'current_order' ? true : false">
                <k-option v-for="(value, key) in validRangeOptionMap" :selected="editPara.validRange == key" :key="key" :value="key" :label="value">{{ value }}</k-option>
              </k-select>
            </y-query-item>
            <y-query-item>
              <k-select placeholder="请选择" clearable :class="css.selectW" v-model="editPara.validOperator">
                <k-option v-for="(value, key) in validOperatorOptionMap" :selected="editPara.validOperator == key" :key="key" :value="key" :label="value">{{ value }}</k-option>
              </k-select>
            </y-query-item>
            <y-query-item>
              <k-input placeholder="请输入正整数或两位小数" block clearable v-model="editPara.validValue"></k-input>
            </y-query-item>
            <y-query-item>
              <k-select placeholder="请选择" clearable :class="css.selectW" v-model="editPara.validUnit">
                <k-option v-for="(value, key) in validUnitOptionMap" :selected="editPara.validUnit == key" :key="key" :value="key" :label="value">{{ value }}</k-option>
              </k-select>
            </y-query-item>
          </y-query>
        </y-form-item>
        <y-form-item title="状态:" required>
          <div>
            <k-radio v-model="editPara.isDisabled" value="0">启用</k-radio>
            <k-radio v-model="editPara.isDisabled" value="1">停用</k-radio>
          </div>
        </y-form-item>
      </y-form>
    </template>
    <template v-else></template>
    <div slot="bottom" v-if="!isView">
      <k-button @click="onReset" v-if="isEdit">重置</k-button>
      <k-button @click="onCancel(true, false)" v-else>取消</k-button>
      <k-button type="primary" @click="onSave" :disabled="saveButtonStatus">保存</k-button>
    </div>
  </y-view>
</template>

<script>
import {
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
  NESTLE_TRADE_BACK_SERVER_ORDER_RULE_OPTION_MAP,
  NESTLE_TRADE_BACK_SERVER_ORDER_RULE_CREATE,
  NESTLE_TRADE_BACK_SERVER_ORDER_RULE_UPDATE,
  NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_DICT_LIST,
  NESTLE_TRADE_BACK_SERVER_ORDER_RULE_DETAIL,
} from "@/assets/modules/apiList";
const initEditPara = () => ({
  name: "",
  isDisabled: "",
  tradeModeList: [],
  validBy: "",
  validOperator: "",
  validRange: "",
  validUnit: "",
  validValue: "",
  saleChannelList: [],
});
export default {
  data() {
    return {
      isLoading: false,
      isSaving: false,
      isEdit: false,
      isView: false,
      editPara: initEditPara(),
      channelList: [],
      tradeList: [],
      validByOptionMap: {},
      validRangeOptionMap: {},
      validOperatorOptionMap: {},
      validUnitOptionMap: {},
      originData: {},
    };
  },
  computed: {
    saveButtonStatus() {
      let status = false;
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (!this.isView) {
        let name = para.name.toString().replace(/\s*/g, "");
        if (
          name.length < 2 ||
          para.tradeModeList.length === 0 ||
          para.saleChannelList.length === 0 ||
          !para.validBy ||
          !para.validOperator ||
          (para.validBy != "current_order" && !para.validRange) ||
          !para.validUnit ||
          !para.validValue ||
          (!para.isDisabled && para.isDisabled != "0")
        ) {
          status = true;
        }
      }
      return status;
    },
  },
  watch: {
    "editPara.validBy": {
      handler(newName, oldName) {
        if (newName == "current_order") {
          delete this.validUnitOptionMap.mobile_count;
          delete this.validUnitOptionMap.order_count;
          delete this.validUnitOptionMap.id_count;
          delete this.validUnitOptionMap.address_count;
        } else if (newName == "buyer_id") {
          delete this.validUnitOptionMap.id_count;
        } else if (newName == "mobile") {
          delete this.validUnitOptionMap.mobile_count;
        } else if (newName == "address") {
          delete this.validUnitOptionMap.address_count;
        }
      },
      immediate: true,
    },
  },
  methods: {
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "placeOrderManagement",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },
    onReset() {
      this.editPara = JSON.parse(JSON.stringify(this.originData));
    },
    onSave() {
      const { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      this.isSaving = true;
      this.isLoading = false;
      this.$fetch({
        api: this.isEdit ? NESTLE_TRADE_BACK_SERVER_ORDER_RULE_UPDATE : NESTLE_TRADE_BACK_SERVER_ORDER_RULE_CREATE,
        para,
      })
        .then((res) => {
          this.isSaving = false;
          this.isLoading = false;
          tip("操作成功");
          this.onCancel(true, true);
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
    getChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {},
      }).then((res) => {
        this.channelList = res || [];
      });
    },
    getOptionList() {
      this.$fetch({
        api: NESTLE_TRADE_BACK_SERVER_ORDER_RULE_OPTION_MAP,
        para: {},
      }).then((res) => {
        let optionConfig = res;
        this.validByOptionMap = optionConfig.validByOptionMap;
        this.validRangeOptionMap = optionConfig.validRangeOptionMap;
        this.validOperatorOptionMap = optionConfig.validOperatorOptionMap;
        this.validUnitOptionMap = optionConfig.validUnitOptionMap;
      });
    },
    getTradeList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_DICT_LIST,
        para: { dtkey: "tradeMode" },
      }).then((res) => {
        this.tradeList = res[0].dictValues;
      });
    },
    getRuleDetail(id) {
      this.$fetch({
        api: NESTLE_TRADE_BACK_SERVER_ORDER_RULE_DETAIL,
        para: { id },
      })
        .then((res) => {
          this.originData = JSON.parse(JSON.stringify(res));
          this.editPara = res;
          let tradeModeList = [];
          let saleChannelList = [];
          for (let i = 0; i < this.editPara.tradeModeList.length; i++) {
            tradeModeList.push(this.editPara.tradeModeList[i].code);
          }
          for (let i = 0; i < this.editPara.saleChannelList.length; i++) {
            saleChannelList.push(this.editPara.saleChannelList[i].saleChannelCode);
          }
          this.editPara.tradeModeList = tradeModeList;
          this.editPara.saleChannelList = saleChannelList;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getChannelList();
    this.getOptionList();
    this.getTradeList();
    const { id, edit, view } = this.$route.query;
    if (id) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
      }

      this.getRuleDetail(id);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { id, edit, view } = to.query;
    this.editPara = initEditPara();
    if (id) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
      }
      this.getRuleDetail(id);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
    next();
  },
};
</script>

<style lang="postcss" module="css">
.selectW {
  width: 165px;
}
.inputW {
  width: 300px !important;
}
</style>
